export const DEFAULT_CHAT_MODEL = "openai/gpt-5.6-luna";
export const DEFAULT_VISION_MODEL = "openai/gpt-5.6-luna";

const NON_CHAT_MARKERS = [
  "tts",
  "image",
  "dall",
  "whisper",
  "embedding",
  "moderation",
  "transcribe",
  "audio",
  "realtime",
] as const;

const MIN_OPENAI_VERSION = 5.5;

function hasMinVersion(id: string, min: number): boolean {
  const match = /\d+\.\d+/.exec(id);
  return match !== null && Number.parseFloat(match[0]) >= min;
}

export function isChatModelId(id: string): boolean {
  if (id.startsWith("openrouter/google/gemini-3")) return true;
  if (id.startsWith("openrouter/anthropic/claude-")) return true;
  if (!id.startsWith("openai/")) return false;
  if (NON_CHAT_MARKERS.some((marker) => id.includes(marker))) return false;
  return hasMinVersion(id, MIN_OPENAI_VERSION);
}

export function isVisionModelId(id: string): boolean {
  return isChatModelId(id);
}

export function buildModelOptions(
  fetchedIds: readonly string[],
  predicate: (id: string) => boolean,
  defaultId: string,
  currentValue: string,
): string[] {
  const filtered = fetchedIds.filter(predicate);
  const options = filtered.length > 0 ? [...filtered] : [defaultId];
  if (!options.includes(defaultId)) options.unshift(defaultId);
  if (currentValue !== "" && !options.includes(currentValue)) {
    options.push(currentValue);
  }
  return options;
}
